// Pack size is a variant option, not cart quantity. Native Shopify product forms submit the actual ID.
const states=new WeakMap();
const packNumber=value=>{
 const match=String(value).trim().toLowerCase().match(/^(?:pack\s*(?:of\s*)?)?(1|5|10|20|30)\s*(?:packs?|pieces?|件装|件)?$/);
 return match?Number(match[1]):null;
};
function initialise(picker){
 if(states.has(picker))return;
 const card=picker.closest('.jw-quick-card,.jw-order-row');
 let data;try{data=JSON.parse(picker.querySelector('.jw-pack-data').textContent);}catch{return;}
 const variants=data.variants;
 let packIndex=data.options.findIndex((name,index)=>/pack|package|包装|件装/i.test(name)&&variants.some(v=>packNumber(v.options[index])));
 if(packIndex<0)packIndex=data.options.findIndex((name,index)=>variants.every(v=>/^\s*(?:1|5|10|20|30)\s*packs?\s*$/i.test(v.options[index])));
 const singleDefault=variants.length===1&&variants[0].options[0]==='Default Title';
 const state={card,data,packIndex,pack:1,selected:[],singleDefault};states.set(picker,state);
 if(packIndex<0&&!singleDefault){
  const link=document.createElement('a');link.href=data.url;link.textContent='Choose options on product page';picker.querySelector('.jw-pack-status').append(link);return;
 }
 const first=variants.find(v=>packNumber(v.options[packIndex])===1)||variants[0];
 state.selected=[...first.options];
 data.options.forEach((name,index)=>{
  if(index===packIndex||singleDefault)return;
  const label=document.createElement('label'),select=document.createElement('select');
  label.append(document.createTextNode(name));select.dataset.optionIndex=index;
  for(const value of new Set(variants.map(v=>v.options[index]))){const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);}
  select.value=state.selected[index];label.append(select);picker.querySelector('.jw-other-options').append(label);
 });
 update(picker,true);
}
function matches(state,variant,pack){return(state.singleDefault?pack===1:packNumber(variant.options[state.packIndex])===pack)&&variant.options.every((value,index)=>index===state.packIndex||state.singleDefault||value===state.selected[index]);}
function update(picker,resetQuantity){
 const state=states.get(picker),{card,data}=state;
 if(state.packIndex<0&&!state.singleDefault)return;
 const variant=data.variants.find(v=>matches(state,v,state.pack));
 for(const button of picker.querySelectorAll('[data-pack]')){
  const pack=Number(button.dataset.pack),candidate=data.variants.find(v=>matches(state,v,pack));
  button.disabled=!candidate?.available;button.setAttribute('aria-pressed',String(pack===state.pack));
  button.title=!candidate?'Not offered':!candidate.available?'Sold out':'';
 }
 const form=card.querySelector('.jw-order-form form'),id=form.querySelector('[name=id]');
 id.value=variant?String(variant.id):'';id.disabled=!variant?.available;
 const button=form.querySelector('[name=add]');button.disabled=!variant?.available;
 // Preserve the theme's animation/checkmark children while replacing just the button label.
 let text=[...button.childNodes].find(node=>node.nodeType===3&&node.textContent.trim());
 if(!text){text=document.createTextNode('');button.prepend(text);}
 text.textContent=variant?(variant.available?'Add to cart':'Sold out'):'Unavailable';
 const price=card.querySelector('.jw-order-price');price.replaceChildren();
 if(variant){if(variant.compare){const old=document.createElement('s');old.textContent=variant.compare;price.append(old);}const current=document.createElement('span');current.textContent=variant.price;price.append(current);}
 else price.textContent='—';
 const quantity=form.querySelector('[name=quantity]'),selector=quantity.closest('quantity-selector-component');
 if(selector)selector.dataset.variantId=variant?.id||'';
 quantity.disabled=!variant?.available;quantity.min=variant?.min||1;quantity.step=variant?.step||1;quantity.dataset.min=quantity.min;quantity.dataset.cartQuantity=variant?.cart||0;
 if(variant?.max!=null)quantity.max=variant.max;else quantity.removeAttribute('max');
 if(resetQuantity)quantity.value=quantity.min;
 for(const control of selector?.querySelectorAll('button')||[])control.disabled=!variant?.available;
 picker.querySelector('.jw-pack-status').textContent=!variant?'This pack is not offered for the selected options.':!variant.available?'This combination is sold out.':'';
 card.querySelector('.jw-order-title').href=data.url+(variant?'?variant='+variant.id:'');
}
document.addEventListener('click',event=>{
 const button=event.target.closest?.('.jw-pack-picker [data-pack]');if(!button)return;
 event.preventDefault();event.stopPropagation();
 const picker=button.closest('.jw-pack-picker');initialise(picker);
 if(button.disabled)return;states.get(picker).pack=Number(button.dataset.pack);update(picker,true);
},true);
document.addEventListener('change',event=>{
 const select=event.target.closest?.('.jw-pack-picker select');if(!select)return;
 const picker=select.closest('.jw-pack-picker'),state=states.get(picker);
 state.selected[Number(select.dataset.optionIndex)]=select.value;update(picker,true);
});
document.addEventListener('submit',event=>{
 const card=event.target.closest?.('.jw-order-row,.jw-quick-card');
 const picker=card?.querySelector('.jw-pack-picker');if(!picker)return;
 initialise(picker);const state=states.get(picker);
 const variant=state?.data.variants.find(v=>matches(state,v,state.pack));
 if(!variant?.available||event.target.querySelector('[name=id]')?.value!==String(variant.id)){event.preventDefault();event.stopImmediatePropagation();}
},true);
function scan(root){if(root.matches?.('.jw-pack-picker'))initialise(root);root.querySelectorAll?.('.jw-pack-picker').forEach(initialise);}
scan(document);
new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)scan(node);}).observe(document.documentElement,{childList:true,subtree:true});
